document.addEventListener("DOMContentLoaded", function () {
  const openBtn = document.getElementById("open-size-chart");
  const closeBtn = document.querySelector(".close-size-chart");
  const popup = document.getElementById("size-chart-popup");

  if (openBtn && popup) {
    openBtn.addEventListener("click", function (event) {
      event.preventDefault();
      popup.style.display = "block";
    });

    closeBtn.addEventListener("click", function () {
      popup.style.display = "none";
    });

    window.addEventListener("click", function (event) {
      if (event.target === popup) {
        popup.style.display = "none";
      }
    });
  }
});
